import { a as r } from "./a-callable.js";
import { t as a } from "./to-object.js";
import { i as o } from "./indexed-object.js";
import { l as t } from "./length-of-array-like.js";
var e = TypeError,
  i = function i(_i) {
    return function (f, n, l, m) {
      r(n);
      var s = a(f),
        c = o(s),
        p = t(s),
        u = _i ? p - 1 : 0,
        j = _i ? -1 : 1;
      if (l < 2) for (;;) {
        if (u in c) {
          m = c[u], u += j;
          break;
        }
        if (u += j, _i ? u < 0 : p <= u) throw e("Reduce of empty array with no initial value");
      }
      for (; _i ? u >= 0 : p > u; u += j) u in c && (m = n(m, c[u], u, s));
      return m;
    };
  },
  f = {
    left: i(!1),
    right: i(!0)
  };
export { f as a };